<template>
  <div>
    <div style="text-align: center">
      <loading :active.sync="carregando" :is-full-page="true"></loading>
    </div>

      <b-container fluid class="pb-3">
        <b-row>
          <b-col sm="12" md="6">
            <p class="h3">REATIVA BH</p>
            <p>
              <!-- É um programa instituído pela Lei 11.311/2021 e regulamentado pelo Decreto 17.719/2021, que concede descontos para pagamento à vista ou parcelado, de débitos municipais, por prazo determinado. Estão inseridos no programa débitos municipais vencidos até 31/12/2020. Quanto a valores referentes ao ISSQN não recolhido e confessados espontaneamente para os fatos geradores ocorridos até 30/11/2020. -->
               É um programa instituído por Lei específica e temporária,
               que concede descontos para pagamento à vista ou parcelado, 
               de débitos municipais, por prazo determinado. 
               Estão inseridos no programa débitos municipais vencidos até 31/08/2023.
               Quanto a valores referentes ao ISSQN não recolhido e 
               confessados espontaneamente estão inseridos os fatos geradores
               ocorridos até 31/07/2023.
            </p>
          </b-col>
        </b-row>        
      </b-container>

      <h3 class="text-center">SERVIÇOS OFERECIDOS</h3>

      <b-container fluid class="pt-3">
      <b-row class="row-gap-md">
        <b-col md="3">
            <botao-inicial
              class="link-card"
              @abrirModal="abrirModal('modal-informativo')"
              titulo="Informação sobre o programa" 
              descricao="Clique nesta opção para saber mais sobre o programa ReativaBh." 
              texto-alternativo="Informação sobre o programa" icon="info-circle" />
        </b-col>
        <b-col md="3" v-if="permissaoAcesso">
          <router-link
            :to="{ name: 'USC.12.282' }" 
            class="link-card"
          >
            <botao-inicial 
               titulo="Aderir ao PROGRAMA REATIVA BH" 
               descricao="Acesse esta opção para emissão de DRAM com opções de descontos para pagamento à vista ou parcelado." 
               texto-alternativo="Aderir ao Programa Reativa BH" 
               icon="calculator" />
          </router-link>
        </b-col>
        <b-col md="3" v-if="permissaoAcesso">
          <botao-inicial 
            class="link-card"
            @abrirModal="abrirModal('modal-guia')"
            titulo="Consultar lançamentos DRAM" 
            descricao="Acesse esta opção para consultar todos os lançamentos incluídos em um DRAM específico." 
            texto-alternativo="Consultar Lançamentos DRAM" 
            icon="search" 
          />
        </b-col>
        <b-col md="3" v-if="false">
          <a
            class="link-card"

            href="https://fazenda.pbh.gov.br/ReativaBH2/"
            target="_blank"
          >
            <botao-inicial 
                      titulo="Confissão Espontânea ISSQN" 
                      descricao="Acesse essa opção para confessar valores devidos e não recolhidos de ISSQN para os fatos geradores ocorridos até 31/07/2023, e, em seguida, ADERIR AO PROGRAMA REATIVA BH" 
                      texto-alternativo="Confissão Espontânea ISSQN" 
                      icon="credit-card" />
          </a>
        </b-col>
        <b-col md="3" v-if="false">
          <a 
            class="link-card"
            href="https://bhresolve.cartoriosdeprotestodebh.com.br/limpanome"
            target="_blank"
          >
            <botao-inicial titulo="Acessar Guias Custas Cartoriais" descricao="Esta opção permite emitir guias dos cartórios onde existem débitos protestados, para quitação das custas e emolumentos (Não há descontos)" texto-alternativo="Acessar Guias Custas Cartoriais" icon="building"/>
          </a>
        </b-col>
      </b-row>
    </b-container>

    <b-modal
      ref="modal-guia"
      title="Lançamentos por DRAM"
      @hide="limparCampos"
      hide-footer
      scrollable
      centered
      size="lg"
    >
      <div v-if="mensagemErroGuia">
        <b-alert show variant="danger" dismissible>
          <b-icon variant="danger" icon="x-circle-fill" />
          {{ mensagemErroGuia }}
        </b-alert>
      </div>

      <b-row class="mb-3">
        <b-col sm="4" md="3" align-self="end" class="ml-3">
          <label for="numeroGuia"><strong>Número do DRAM:</strong></label>
        </b-col>
        <b-col sm="8" md="8" align-self="start">
          <b-form-input
            id="numeroGuia"
            v-model="numeroGuia"
            v-mask="['##.##.#######.##']"
            placeholder="Digite o Número do DRAM"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-3 float-right">
        <b-button
          class="mr-3"
          variant="secondary"
          @click="fecharModal('modal-guia')"
        >
          Cancelar
        </b-button>
        <b-button
          class="mr-3"
          variant="primary"
          :disabled="numeroGuia.length != 16"
          @click="enviarGuiar()"
        >
          Enviar
        </b-button>
      </b-row>
    </b-modal>

    <b-modal
      ref="modal-informativo"
      title="Sobre o programa"
      hide-footer
      scrollable
      centered
      size="lg"
    >
      <div class="container mt-3">
        <section class="apresentacao text-dark py-3 px-md-3">
          <div class="texto-apresentacao text-dark h6">
            <p>
              <!-- É um programa instituído pela Lei 11.311/2021 e regulamentado pelo
              Decreto 17.719/2021, que concede descontos para pagamento à vista
              ou parcelado, de débitos municipais, por prazo determinado. Estão
              inseridos no programa débitos municipais vencidos até 31/12/2020.
              Quanto a valores referentes ao ISSQN não recolhido e confessados
              espontaneamente para os fatos geradores ocorridos até 30/11/2020. -->
               É um programa instituído por Lei específica e temporária,
               que concede descontos para pagamento à vista ou parcelado, 
               de débitos municipais, por prazo determinado. 
               Estão inseridos no programa débitos municipais vencidos até 31/08/2023.
               Quanto a valores referentes ao ISSQN não recolhido e 
               confessados espontaneamente estão inseridos os fatos geradores
               ocorridos até 31/07/2023.
              <br /><br />
              Os descontos serão aplicados sobre multa, juros e acréscimos moratórios. Os
              descontos concedidos são diferenciados para o pagamento à vista e
              parcelado
              <a href="#" class="text-primary" @click="abrirModal('modal-descontos')"
                >(Veja aqui os descontos oferecidos)</a
              >. Os débitos que já se encontram parcelados também poderão ser
              inseridos no programa. Existem algumas exceções que não permitem a
              adesão ao programa, como por exemplo,  multa de trânsito, ISSQN retido 
              na fonte e não recolhido nos prazos estabelecidos na legislação 
              municipal (salvo após inscrição em dívida ativa), débitos de natureza 
              contratual e aqueles lançados por exercício e correspondentes ao ano de 2023.
              <a href="#" class="text-primary" @click="abrirModal('modal-excecoes')">
                (Veja aqui todas as exceções)</a
              >.
            </p>
          </div>
        </section>

        <div class="my-3" style="text-align: center">
          <b-col>
            <a
              class="text-primary"
              @click="abrirModal('modal-perguntas-e-respostas')"
              v-b-tooltip.hover="{ variant: 'primary' }"
              title="Esta opção irá leva-lo para a página com as principais perguntas frequentes sobre o programa ReativaBH."
            >
              <b-icon
                class="icon"
                variant="primary"
                font-scale="2"
                align="center"
                icon="question"
              />
              Perguntas frequentes
            </a>
          </b-col>

          <b-col class="my-3">
            <a
              class="text-primary"
              @click="abrirModal('modal-bancos-conveniados')"
              v-b-tooltip.hover="{ variant: 'primary' }"
              title="Esta opção irá leva-lo para a os bancos conveniados da PBH."
            >
              <b-icon
                class="icon"
                variant="primary"
                font-scale="2"
                align="center"
                icon="building"
              />
              Bancos conveniados
            </a>
          </b-col>

          <!-- <div class="d-flex justify-content-between mt-3">
            <div class="botao-video">
              <a
                class="text-primary"
                @click="abrirModal('modal-video1')"
                v-b-tooltip.hover="{ variant: 'primary' }"
                title="Video instrutivo sobre emissão de DRAM."
              >
                <b-icon
                  class="icon"
                  variant="primary"
                  font-scale="2"
                  align="center"
                  icon="camera-video-fill"
                />
                EMISSAO DE DRAM
              </a>
            </div>

            <div class="botao-video">
              <a
                class="text-primary"
                @click="abrirModal('modal-video2')"
                v-b-tooltip.hover="{ variant: 'primary' }"
                title="Video instrutivo sobre cancelamento de parcelamento."
              >
                <b-icon
                  class="icon"
                  variant="primary"
                  font-scale="2"
                  align="center"
                  icon="camera-video-fill"
                />
                CANCELAMENTO DE PARCELAMENTO
              </a>
            </div>

            <div class="botao-video">
              <a
                class="text-primary"
                @click="abrirModal('modal-video3')"
                v-b-tooltip.hover="{ variant: 'primary' }"
                title="Video instrutivo sobre emissão de DRAM."
              >
                <b-icon
                  class="icon"
                  variant="primary"
                  font-scale="2"
                  align="center"
                  icon="camera-video-fill"
                />
                CONFISSÃO ESPONTÂNEA ISSQN
              </a>
            </div>
          </div> -->

        </div>
      </div>
    </b-modal>

    <b-modal
      ref="modal-bancos-conveniados"
      title="Bancos conveniados"
      hide-footer
      scrollable
      centered
      size="xl"
    >
      <p class="font-dark h5">A PBH possui convênio com os seguintes Bancos:</p>
      <p class="font-dark h6">Existem órgãos que possuem convênios específicos.</p>
      <p class="font-dark h7">Confira abaixo os convênios para pagamento do DRAM:</p>
      <p>
      <b><i>- TESOURO MUNICIPAL:</i></b> 
      PAGAVEL SOMENTE NOS BANCOS: BRADESCO, MERCANTIL, SAFRA, INTER, BANCOOB, ITAU, BANCO DO BRASIL, SANTANDER, CAIXA ECONOMICA FEDERAL E LOTERICAS.
      <br />
      <b><i>- PRODABEL:</i></b>
      PAGAVEL SOMENTE NO BANCO DO BRASIL E CAIXA ECONOMICA FEDERAL.
      <br />
      <b><i>- BELOTUR:</i></b>
      PAGAVEL SOMENTE NA CAIXA ECONOMICA FEDERAL.
      <br />
      <b><i>- BHTRANS:</i></b>
      PAGAVEL SOMENTE NOS BANCOS: CEF, BRADESCO, SANTANDER, ITAU, INTER, BANCOOB, MERCANTIL DO BRASIL E ORIGINAL.
      <br />
      <b><i>- URBEL:</i></b>	
      PAGAVEL SOMENE NA CAIXA ECONOMICA FEDERAL E LOTERICAS.
      <br />
      <b><i>- FUFIN:</i></b>
      PAGAVEL SOMENTE NOS BANCOS: ITAU, BANCO DO BRASIL, BANCOOB, MERCANTIL DO BRASIL, BRADESCO, BANCO INTER E CAIXA ECONOMICA FEDERAL.
      <br />
      <b><i>- BHPREV:</i></b>
      PAGAVEL SOMENTE NOS BANCOS: ITAU, BANCO DO BRASIL, BANCOOB, MERCANTIL DO BRASIL, BRADESCO, BANCO INTER E CAIXA ECONOMICA FEDERAL.
     </p>
      <b-row class="flex-wrap justify-content-between" align-v="center">
        <b-col align="center" sm="4">
          <img
            src="/imgs/bancoBradesco.png"
            class="img-fluid"
            alt="Banco Bradesco"
          />
        </b-col>

        <b-col align="center" sm="4">
          <img
            src="/imgs/bancoDoBrasil.png"
            class="img-fluid"
            alt="Banco do Brasil"
          />
        </b-col>

        <b-col align="center" sm="4">
          <img
            src="/imgs/bancoBancoob.png"
            class="img-fluid"
            alt="Banco Bancoob"
          />
        </b-col>
      </b-row>

      <b-row class="flex-wrap justify-content-between" align-v="center">
        <b-col align="center" sm="4">
          <img src="/imgs/bancoInter.png" class="img-fluid" alt="Banco Inter" />
        </b-col>

        <b-col align="center" sm="4">
          <img src="/imgs/bancoItau.png" class="img-fluid" alt="Banco Itaú" />
        </b-col>

        <b-col align="center" sm="4">
          <img src="/imgs/bancoSafra.png" class="img-fluid" alt="Banco Safra" />
        </b-col>
      </b-row>

      <b-row class="flex-wrap justify-content-between" align-v="center">
        <b-col align="center" sm="4">
          <img
            src="/imgs/bancoSantander.png"
            class="img-fluid"
            alt="Banco Santander"
          />
        </b-col>
        <b-col align="center" sm="4">
          <img
            src="/imgs/bancoMercantil.png"
            class="img-fluid"
            alt="Banco Mercantil do Brasil"
          />
        </b-col>

        <b-col align="center" sm="4">
          <img src="/imgs/bancoCaixa.png" class="img-fluid" alt="Banco Caixa" />
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="modal-video1"
      title="VIDEO TUTORIAL"
      hide-footer
      scrollable
      centered
      size="xl"
    >
      <div class="iframe-container">
        <iframe
          width="1004"
          height="565"
          src="https://www.youtube.com/embed/ZERSmKSneW0"
          title="Emissão de DRAM"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </b-modal>

    <b-modal
      ref="modal-video2"
      title="VIDEO TUTORIAL"
      hide-footer
      scrollable
      centered
      size="xl"
    >
      <div class="iframe-container">
        <iframe
          width="1004"
          height="565"
          src="https://www.youtube.com/embed/68o7yXJyDTY"
          title="Cancelar parcelamento"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </b-modal>

    <b-modal
      ref="modal-video3"
      title="VIDEO TUTORIAL"
      hide-footer
      scrollable
      centered
      size="xl"
    >

    <iframe
      width="1004"
      height="565"
      src="https://www.youtube.com/embed/y5LXXceO_xU"
      title="Confissão Espontânea ISSQN"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      ></iframe>
    </b-modal>

    <b-modal
      ref="modal-excecoes"
      title="Exceções"
      hide-footer
      scrollable
      centered
      size="xl"
    >
      <ul>
        <li style="list-style: none">
            Os descontos previstos neste programa não se acumulam com quaisquer outros descontos,
            abatimentos, reduções de valor ou benefícios concedidos ao pagamento à vista ou parcelado
            de dívidas previstos na legislação municipal e não se aplicam aos créditos:
             <br />
          <div class="ml-4">
            I - do Imposto sobre Serviços de Qualquer Natureza — ISSQN — retido na fonte e não
            recolhido nos prazos estabelecidos na legislação municipal, salvo após inscrição em dívida
            ativa;
             <br />
            II – decorrentes da Lei Federal nº 9.503/1997 e da Resolução nº 918/2022 do Conselho
            Nacional de Trânsito – CONTRAN;
             <br />
            III- tributos lançados por exercício correspondentes ao ano 2023.
            <br />
            IV - relativos a multas contratuais.
            <br />            
          </div>
        </li>
      </ul>
    </b-modal>

    <b-modal
      ref="modal-descontos"
      title="Descontos Concedidos"
      hide-footer
      scrollable
      centered
      size="xl"
    >
      <ul>
        <h5 class="mb-3">
          <strong> DÉBITOS TRIBUTÁRIOS, PREÇOS PÚBLICOS, REGULARIZAÇÃO DE EDIFICAÇÕES E POTENCIAL CONSTRUTIVO EXCEDENTE  </strong>
        </h5>

        <li style="list-style: none">
          I - Para pagamento integral e à vista: <br />
          <div class="ml-4">
            a) desconto de 100% (cem por cento) sobre o valor das multas
            moratórias e dos juros de mora para pagamento em até 90 (noventa)
            dias contados da regulamentação desta lei;
          </div>
        </li>

        <br />

        <li style="list-style: none">
          II - Para pagamento parcelado, desconto sobre o valor das multas
          moratórias e dos juros de mora de: <br />
          <div class="ml-4">
            a) 95% (noventa e cinco por cento) para pagamento em até 12 (doze)
            parcelas mensais; <br />
            b) 90% (noventa por cento) para pagamento de 13 (treze) até 18
            (dezoito) parcelas mensais; <br />
            c) 85% (oitenta e cinco por cento) para pagamento de 19 (dezenove)
            até 24 (vinte e quatro) parcelas mensais; <br />
            d) 80% (oitenta por cento) para pagamento de 25 (vinte e cinco) até
            30 (trinta) parcelas mensais; <br />
            e) 75% (setenta e cinco por cento) para pagamento de 31 (trinta e
            uma) até 36 (trinta e seis) parcelas mensais; <br />
            f) 70% (setenta por cento) para pagamento de 37 (trinta e sete) até
            42 (quarenta e duas) parcelas mensais;<br />
            g) 65% (sessenta e cinco por cento) para pagamento de 43 (quarenta e
            três) até 48 (quarenta e oito) parcelas mensais; <br />
            h) 60% (sessenta por cento) para pagamento de 49 (quarenta e nove)
            até 54 (cinquenta e quatro) parcelas mensais; <br />
            i) 55% (cinquenta e cinco por cento) para pagamento de 55 (cinquenta
            e cinco) até 60 (sessenta) parcelas mensais; <br />
            j) 50% (cinquenta por cento) para pagamento de 61 (sessenta e uma)
            até 66 (sessenta e seis) parcelas mensais; <br />
            k) 45% (quarenta e cinco por cento) para pagamento de 67 (sessenta e
            sete) até 72 (setenta e duas) parcelas mensais;<br />
            l) 40% (quarenta por cento) para pagamento de 73 (sessenta e três)
            até 78 (setenta e oito) parcelas mensais; <br />
            m) 35% (trinta e cinco por cento) para pagamento de 79 (sessenta e
            nove) até 84 (oitenta e quatro) parcelas mensais.
            <br />
          </div>
        </li>

        <h5 class="my-3">
          <strong>
             MULTAS ADMINISTRATIVAS E PENALIDADES APLICADAS POR 
             DESCUMPRIMENTO DE OBRIGAÇÕES TRIBUTÁRIAS ACESSÓRIAS
          </strong>
        </h5>

        <li style="list-style: none">
          I — Para pagamento à vista: <br />
          <div class="ml-4">
              80% (oitenta por cento) sobre o valor do crédito, para pagamento integral e à vista, em até
              trinta dias contados da regulamentação desta lei;<br />
              70% (setenta por cento) sobre o valor do crédito, para pagamento integral e à vista, em até
              sessenta dias contados da regulamentação desta lei;<br />
          </div>
        </li>

        <br />

        <li style="list-style: none">
          II - Para pagamento parcelado: <br />
          <div class="ml-4">
              a) 60% (sessenta por cento), para pagamento parcelado de 2 (duas) até 12 (doze) parcelas
              mensais;<br />
              b) 50% (cinquenta por cento), para pagamento parcelado de 13 (treze) até 24 (vinte e quatro)
              parcelas mensais;<br />
              c) 40% (quarenta por cento), para pagamento parcelado de 25 (vinte e cinco) até 36 (trinta e
              seis) parcelas mensais;<br />
              d) 30% (trinta por cento), para pagamento parcelado de 37 (trinta e sete) até 48 (quarenta e
              oito) parcelas mensais;<br />
              e) 20% (vinte por cento), para pagamento parcelado de 49 (quarenta e nove) a 60 (sessenta)
              parcelas mensais.<br />
          </div>
        </li>
      </ul>
    </b-modal>

    <b-modal
      ref="modal-perguntas-e-respostas"
      hide-footer
      title="Perguntas frequentes"
      scrollable
      size="xl"
    >
      <ul>
        <li style="list-style: none">
          <strong> 1 - O que é o programa Reativa BH ? </strong> <br />
          É um programa que concede, por meio de Lei específica e temporária, 
          descontos para o pagamento, à vista ou parcelado, 
          de débitos junto ao Município, vencidos até 31/08/2023.
           <br /><br />
          <strong>
            2 - Qualquer débito junto ao Município poderá ser beneficiado com os 
            descontos previstos no programa Reativa BH ?
          </strong>
          <br />
          <b>Não.</b> Os descontos previstos neste programa não se aplicam aos créditos:<br />
          <b>I -</b> do Imposto sobre Serviços de Qualquer Natureza — ISSQN — retido na fonte e não recolhido nos prazos estabelecidos na legislação municipal, salvo após inscrição em dívida ativa;<br />
          <b>II –</b> decorrentes da Lei Federal nº 9.503/1997 e da Resolução nº 918/2022 do Conselho Nacional de Trânsito – CONTRAN;<br />
          <b>III-</b> tributos lançados por exercício correspondentes ao ano 2023.<br /> 
          <b>IV -</b> relativos a multas contratuais.<br />
          <br />
          <strong>
             3 - Qual o prazo para a adesão ao programa Reativa BH ?
          </strong
          ><br />
          A adesão ao programa deverá ser feita até 90 dias, 
          contados da regulamentação da Lei específica e temporária, portanto, 
          V.S. ª poderá aderir até 27 de março de 2024.<br /><br />
          <b>Mas atenção:</b> o programa faculta descontos diferentes de 
          acordo com a forma e condições escolhidas para o pagamento.
          <br /><br />

          <strong>
            4 - Quais as formas e condições ofertadas 
            para o pagamento de débitos no Reativa BH ?
          </strong
          ><br />
          Para os débitos tributários, preços públicos e obrigações relacionadas
          à regularização de edificações, ao potencial construtivo excedente, 
          à outorga onerosa do direito de construir - ODC, bem como à 
          contrapartida devida pelo fechamento de varandas, 
          o pagamento poderá ser integral e à vista, ou parcelado, 
          com descontos sobre os acréscimos moratórios (multa, juros e selic), 
          conforme condições especificadas nas tabelas abaixo.
          <br /><br />
        </li>

        <table class="w-100">
          <tr class="bg-primary text-white">
            <td colspan="2" class="text-center">
              <strong>CONDIÇÕES PARA PAGAMENTO INTEGRAL E À VISTA</strong>
            </td>
          </tr>
          <tr>
            <td class="text-center">
              <strong>Pagamento durante a vigência do programa ( 29/12/2023 a 27/03/2024 )</strong>
            </td>
            <td >Desconto de 100% (cem por cento)</td>
          </tr>        
        </table>

        <table class="w-100 mt-5">
          <tr class="bg-primary text-white">
            <td colspan="2" class="text-center">
              <strong>CONDIÇÕES PARA PAGAMENTO PARCELADO</strong>
            </td>
          </tr>
          <tr>
            <td class="text-center"><strong>QUANTIDADE DE PARCELAS</strong></td>
            <td class="text-center">
              <strong>DESCONTO CONCEDIDO</strong
              ><span class="text-danger">*</span>
            </td>
          </tr>

          <tr>
            <td>em até 12 parcelas mensais</td>
            <td>95% (noventa e cinco por cento)</td>
          </tr>

          <tr>
            <td>de 13 até 18 parcelas mensais</td>
            <td>90% (noventa por cento)</td>
          </tr>

          <tr>
            <td>de 19 até 24 parcelas mensais</td>
            <td>85% (oitenta e cinco por cento)</td>
          </tr>

          <tr>
            <td>de 25 até 30 parcelas mensais</td>
            <td>80% (oitenta por cento)</td>
          </tr>

          <tr>
            <td>de 31 até 36 parcelas mensais</td>
            <td>75% (setenta e cinco por cento)</td>
          </tr>

          <tr>
            <td>de 37 até 42 parcelas mensais</td>
            <td>70% (setenta por cento)</td>
          </tr>

          <tr>
            <td>de 43 até 48 parcelas mensais</td>
            <td>65% (sessenta e cinco por cento)</td>
          </tr>

          <tr>
            <td>de 49 até 54 parcelas mensais</td>
            <td>60% (sessenta por cento)</td>
          </tr>

          <tr>
            <td>de 55 até 60 parcelas mensais</td>
            <td>55% (cinquenta e cinco por cento)</td>
          </tr>

          <tr>
            <td>de 61 até 66 parcelas mensais</td>
            <td>50% (cinquenta por cento)</td>
          </tr>

          <tr>
            <td>de 67 até 72 parcelas mensais</td>
            <td>45% (quarenta e cinco por cento)</td>
          </tr>

          <tr>
            <td>de 73 até 78 parcelas mensais</td>
            <td>40% (quarenta por cento)</td>
          </tr>

          <tr>
            <td>de 79 até 84 parcelas mensais</td>
            <td>35% (trinta e cinco por cento)</td>
          </tr>
        </table>

        <br />
        Para os débitos relativos a multas administrativas e penalidades
        aplicadas pelo descumprimento de obrigações tributárias acessórias, o
        pagamento poderá ser integral e à vista, ou parcelado, com descontos
        sobre o valor consolidado do débito, conforme condições especificadas
        nas tabelas abaixo.
        <br /><br />

        <table class="w-100">
          <tr class="bg-primary text-white">
            <td colspan="2" class="text-center">
              <strong>CONDIÇÕES PARA PAGAMENTO INTEGRAL E À VISTA</strong>
            </td>
          </tr>
          <tr>
            <td class="text-center">
              <strong>Pagamento até o dia 27/01/2024</strong>
            </td>
            <td class="text-center">Desconto de 80% (oitenta por cento)</td>
          </tr>
          <tr>
            <td class="text-center">
              <strong>Pagamento entre os dias 28/01 e 26/02/2024</strong>
            </td>
            <td class="text-center">Desconto de 70% (setenta por cento)</td>
          </tr>
        </table>

        <br /><br />

        <table class="w-100 mt-5">
          <tr class="bg-primary text-white">
            <td colspan="2" class="text-center">
              <strong>CONDIÇÕES PARA PAGAMENTO PARCELADO</strong>
            </td>
          </tr>
          <tr>
            <td class="text-center"><strong>QUANTIDADE DE PARCELAS</strong></td>
            <td class="text-center">
              <strong>DESCONTO CONCEDIDO</strong
              ><span class="text-danger">*</span>
            </td>
          </tr>

          <tr>
            <td>em até 12 parcelas mensais</td>
            <td>60% (sessenta por cento)</td>
          </tr>

          <tr>
            <td>de 13 até 24 parcelas mensais</td>
            <td>50% (cinquenta por cento)</td>
          </tr>

          <tr>
            <td>de 25 até 36 parcelas mensais</td>
            <td>40% (quarenta por cento)</td>
          </tr>

          <tr>
            <td>de 37 até 48 parcelas mensais</td>
            <td>30% (trinta por cento)</td>
          </tr>

          <tr>
            <td>de 49 até 60 parcelas mensais</td>
            <td>20% (vinte por cento)</td>
          </tr>
        </table>

        <br /><br />

        <strong>
          5 - E como saber se eu estou devendo algo, e o que estou devendo ?
        </strong><br />  
          Para consultar os débitos inseridos no programa Reativa BH acesse o link 
          <a href="https://reativabh.pbh.gov.br" target="_blank"
          >reativabh.pbh.gov.br</a>
           na opção “aderir ao programa Reativa BH”, e para débitos não inseridos no programa acesse o 
           link <a href="https://siatu-tributario.pbh.gov.br/guias" target="_blank"
          >siatu-tributario.pbh.gov.br</a> na opção “gerar DRAM”.
          Ao passar o cursor sobre cada um dos lançamentos exibidos, o sistema apresentará os dados relacionados.
        <br /><br />  

        <strong
          >6 - Os descontos do Reativa BH são cumulativos com outros benefícios
          da legislação tributária municipal ?</strong
        ><br />
        Não. Os descontos do programa não se acumulam com quaisquer outros
        descontos, abatimentos, reduções de valor ou benefícios concedidos ao
        pagamento à vista ou parcelado de dívidas previstos na legislação
        tributária municipal.<br /><br />

        <strong
          >7 - Existe valor mínimo de parcela para os contribuintes Pessoa
          Física e Pessoa Jurídica no parcelamento do programa REATIVA ? </strong><br />
        Sim. Conforme legislação tributária municipal, a parcela mínima deve ser
        de R$50,00 (cinquenta reais) para pessoa física e R$200,00 (duzentos
        reais) para pessoa jurídica.<br /><br />

        <strong
          >8 - Como aderir ao programa Reativa BH e emitir o Documento de
          Recolhimento e Arrecadação Municipal - DRAM utilizado para pagamento
          ou parcelamento dos débitos ?</strong
        ><br />
        O contribuinte deve acessar a página do programa em
        <a href="https://reativabh.pbh.gov.br/" target="_blank"
          >reativabh.pbh.gov.br</a
        >.<br /><br />

        <strong
          >9 - Após o acesso à página do programa Reativa BH foram apresentadas as 
          opções de identificadores para pesquisa dos débitos. Qual devo escolher ?</strong
        ><br />
        A consulta por meio do CPF deve ser feita através da opção “acesso identificado”, 
        fazendo o login com a senha de acesso ao “gov.br”, em razão da LGPD - Lei Geral 
        de Proteção de Dados. Esta opção faz a pesquisa completa do cidadão, desde que as 
        informações cadastrais estejam atualizadas, trazendo todos os débitos existentes 
        referentes a tributos, multas e preços públicos.<br /><br />
        
        A consulta por meio do CNPJ é feita de forma direta, sem necessidade de acesso 
        pelo “gov.br”. A partir da informação do número do CNPJ a pesquisa é feita pela 
        sua raiz, consultando todos os débitos da matriz e filiais, situadas no Município.<br /><br />
        
        A consulta por um identificador, que pode ser um índice cadastral de imóvel, uma 
        inscrição municipal de empresa ou profissional autônomo, um código de perpetuidade, 
        um número de parcelamento ou de processo judicial, é específica, ou seja, é um filtro 
        para selecionar apenas débitos que estão ligados a tais identificadores.<br /><br />

        Nas opções de consulta são informados os débitos com parcelamento em andamento, que 
        poderão ser reparcelados com os descontos do programa Reativa BH.
        <br /><br />

        <strong>
          10 - Eu já aderi ao Programa Reativa no passado, posso aderir a este ?
        </strong><br />
          Os contribuintes que fizeram adesão ao Reativa BH em 2021 poderão acessar a opção 
          “Parcelamento” na página de “Aderir ao programa”, a partir da digitação do número do 
          parcelamento. Será dada a opção de cancelar o parcelamento anterior, para prosseguir 
          com nova adesão, selecionando todos os débitos objetos daquele parcelamento, que serão 
          listados na página de adesão, com a vantagem de que, no atual programa, a atualização das 
          parcelas se dá pela SELIC, representando um índice de atualização menor do que o anterior.<br />  

          Importante destacar que, se ao acessar a página do Reativa BH, você identificar débitos 
          listados em seu nome, significa que os mesmos ainda estão pendentes de negociação e 
          podem compor nova proposta. Neste caso, recomendamos que você faça a adesão para esses, 
          também, para garantir os benefícios do atual programa.
        <br /><br />  

        <strong>
          11 - E o que eu já paguei no Reativa anterior ?
        </strong><br />
          Os valores já pagos até a data de adesão ao Programa Reativa BH de 2023 já estão 
          deduzidos do saldo devedor dos lançamentos listados.
        <br /><br /> 

        <strong
          >12 - Débitos ajuizados podem ser contemplados com os descontos do
          Reativa BH ?</strong
        ><br />
        Sim. E nesse caso, os honorários advocatícios serão recalculados sobre o
        montante do valor do débito, após a aplicação dos descontos.<br /><br />

        <strong
          >13 - Débitos protestados podem ser contemplados com os descontos do
          Reativa BH ?</strong
        ><br />
        Sim. Após o pagamento ou parcelamento dos débitos é enviada
        automaticamente a carta de anuência aos Tabelionatos de Protesto, que
        possibilita o cancelamento do protesto, após a quitação das custas e
        emolumentos cartoriais.<br /><br />
        Para emitir a guia das custas e emolumentos cartoriais, acesse a página
        do programa em
        <a href="https://reativabh.pbh.gov.br" target="_blank"
          >reativabh.pbh.gov.br</a
        >
        e selecione a opção “Acessar Guia Custas Cartoriais”.<br /><br />

        <strong
          >14 - Débitos suspensos podem ser contemplados com os descontos do
          Reativa BH ?</strong
        ><br />
        Sim. Os débitos serão exibidos para a seleção com a situação de
        suspensão, para melhor identificá-los.<br /><br />

        <strong>Mas atenção:</strong>
        a adesão ao programa importa o reconhecimento da dívida e a
        incondicional e definitiva desistência de eventual ação judicial,
        reclamação ou recurso administrativo.<br /><br />

        <strong>15 - Em quais Instituições Financeiras posso realizar o pagamento do
          DRAM ?
        </strong><br />
            As Instituições Financeiras conveniadas com a PBH são: 
            BRADESCO, 
            MERCANTIL, 
            SAFRA, 
            INTER, 
            BANCOOB, 
            ITAÚ, 
            BANCO DO BRASIL, 
            SANTANDER, 
            CAIXA ECONÔMICA FEDERAL, 
            BANCO POSTAL e 
            LOTÉRICAS. Mas há convênios específicos de acordo com os órgãos, 
            e neste caso o pagamento deve ser realizado somente nos bancos descritos no DRAM.
        <br /><br />

        <strong>
          16 - Tenho débito na situação “enviado para protesto”. Como proceder ?
        </strong><br />  
          Débitos nesta situação, por força da legislação, somente podem ser pagos à vista 
          diretamente no Cartório. Para aderir ao programa somente se o débito for protestado, 
          ou seja, não houver pagamento no Cartório e o protesto for efetivado por ele. 
          A partir da situação “protestado” o débito estará disponível para emissão no Reativa BH.
        <br /><br />  

        <strong
          >17 - Foram selecionados vários débitos e nem todos são indicados no
          DRAM. O que devo fazer ?
        </strong><br />
        Você deve emitir um relatório por meio do número do DRAM onde constam
        todos os lançamentos que fazem parte do documento. Para emitir o
        relatório na página principal do programa clique em “Consulta
        lançamentos DRAM”.
        <br /><br />
        Para isso acesse a página do programa em
        <a href="https://reativabh.pbh.gov.br" target="_blank"
          >reativabh.pbh.gov.br
        </a>.
        <br /><br />

        <strong
          >18 - Tenho parcelamento de débitos do ISSQN confessados
          espontaneamente. Posso aderir ao Reativa BH ?</strong
        ><br />
        Sim. Você pode aderir, devendo para tanto solicitar o cancelamento do
        parcelamento existente por meio do serviço 
        “Parcelamento de Débitos - Cancelamento, Dúvidas, Planilhas e Simples Nacional”, 
        disponível no Portal de Serviços da Prefeitura de Belo Horizonte.<br />
        Após receber a resposta de sua solicitação, acesse a página do programa
        em
        <a href="https://reativabh.pbh.gov.br" target="_blank"
          >reativabh.pbh.gov.br</a
        >
        e selecione a opção “Aderir ao Reativa BH”.<br /><br />

        <strong
          >19 - Tenho um ou mais parcelamentos em andamento. Posso aderir ao
          Reativa BH ? Como faço para cancelar o parcelamento e aderir ao
          programa ?
        </strong><br />
        Sim. Você pode emitir o DRAM para adesão ao programa a partir da
        pesquisa do identificador específico, que pode ser um índice cadastral
        de imóvel, inscrição municipal de empresa ou profissional autônomo,
        código de perpetuidade ou pelo CPF/CNPJ. Acesse a página do programa em
        <a href="https://reativabh.pbh.gov.br" target="_blank"
          >reativabh.pbh.gov.br</a
        >.<br />
        Após a exibição dos débitos, deverão ser selecionados todos os que têm
        parcelamentos e clicar em “cancelar parcelamento”, informando um
        telefone celular ou endereço de e-mail para receber o código de
        confirmação. Inserindo o código de confirmação no campo apropriado seu
        parcelamento será cancelado e você poderá prosseguir para a emissão de
        novo DRAM.<br /><br />
       
        <strong>
          20 - Fiz o parcelamento no Reativa BH. Como faço para emitir as demais parcelas ?
        </strong><br /> 
          Você deve acessar <a href="https://siatu-tributario.pbh.gov.br/guias" target="_blank"
          >siatu-tributario.pbh.gov.br/guias</a>.
           <br /><br />
          i) A emissão por meio do CPF deve ser feita através da opção “acesso identificado”, 
          fazendo o login com a senha de acesso ao <a href="https://gov.br" target="_blank"
          >gov.br</a>. Esta opção faz a pesquisa completa do cidadão, trazendo todos os 
          débitos e parcelamentos existentes referentes a tributos, 
          multas e preços públicos.
          <br /><br /> 
          ii) Também pode cadastrar o e-mail para recebimento das parcelas mensais. Através 
          da opção “acesso identificado”, fazendo o login com a senha de acesso ao 
          <a href="https://gov.br" target="_blank">gov.br</a>  
          o sistema exibirá a opção CADASTRO E-MAIL. Siga as instruções.
          <br /><br /> 
          iii) Caso deseje fazer a emissão utilizando somente o número do parcelamento, 
          clique em "GERAR DRAM" e selecione a opção "PARCELAMENTO".
        <br /><br />  

        <strong>
          21 - Qual é a data de vencimento das parcelas de um parcelamento feito no REATIVA BH ?
        </strong><br />
          O vencimento será no dia em que a primeira parcela foi paga. Por exemplo, 
          se a parcela foi paga no dia 20, as parcelas vencerão sempre no dia 20 dos meses subsequentes.
        <br /><br />  

        <strong>
          22 - Quais os encargos legais incidem sobre o parcelamento realizado
          por meio do Reativa BH ?
        </strong><br />

          Os débitos parcelados ficarão sujeitos, a partir da concessão dos descontos, 
          à atualização pela taxa referencial do Sistema Especial de Liquidação e de 
          Custódia – Selic – acumulada mensalmente, calculada a partir do mês subsequente 
          ao do vencimento ou da consolidação do parcelamento até o mês anterior ao do 
          pagamento e de 1% (um por cento) relativamente ao mês em que o pagamento 
          estiver sendo efetuado.
        <br /><br />

        <strong>
          23 - Onde acesso os índices da taxa SELIC mensal?
        </strong><br />
          Para acessar a taxa Selic mensal: <a href="https://www.gov.br/receitafederal/pt-br/assuntos/orientacao-tributaria/pagamentos-e-parcelamentos/taxa-de-juros-selic" target="_blank"
          >clique aqui</a>.
        <br /><br />  

        <strong
          >24 - Efetuei o pagamento da 1ª parcela, quando poderei emitir a
          Certidão Positiva com efeito Negativo ?</strong
        ><br />
        Efetuado o pagamento da 1ª parcela no valor exato até a data de
        vencimento do DRAM, após 3 (três) dias úteis poderá ser emitida a
        Certidão Positiva com efeito Negativo.<br /><br />

        <strong
          >25 - O atraso no pagamento de parcelas ocasionará o cancelamento do
          parcelamento ?</strong
        ><br />
        Sim. O atraso no pagamento de qualquer parcela por período superior a 90
        (noventa) dias ocasionará o cancelamento do parcelamento e a restauração
        do valor original dos débitos reduzidos por meio do programa Reativa BH,
        relativamente às parcelas não pagas.<br /><br />

        <strong
          >26 - Minha empresa possui várias unidades, mas quero selecionar apenas os 
          débitos de uma específica. Como devo proceder ?
        </strong
        ><br />
        Selecione a pesquisa pelo identificador “inscrição municipal”, 
        “índice cadastral” ou “processo judicial”. Podem existir também 
        débitos no CNPJ específico, e neste caso, após pesquisar a empresa, 
        selecione na tela apresentada somente os débitos desejados.<br /><br />

        Também pode ser feita a pesquisa através do acesso identificado, 
        pelo responsável legal da empresa, e na tela serão apresentados os 
        CNPJ’s vinculados ao CPF logado. Selecione a pesquisa pelo identificador 
        inscrição municipal, índice cadastral ou processo judicial.<br /><br />

        A pesquisa também pode ser feita pelo CNPJ, mas neste caso na relação de 
        débitos apresentada devem ser selecionados apenas os débitos da empresa 
        específica.<br /><br />

        Além disso, a pesquisa pode ser feita pelo responsável legal da empresa, 
        através da opção “acesso identificado”, fazendo o login com a senha de 
        acesso ao “gov.br”, pois no ambiente de adesão ao programa serão 
        apresentados os CNPJs vinculados ao CPF logado.
        <br /><br />

        <strong
          >27 - Minha empresa possui valores não recolhidos referentes ao ISSQN.
          Como aderir ao Reativa BH ?</strong
        ><br />
        Os valores do ISSQN não recolhidos, cujos fatos geradores ocorreram até
        dia 30/07/2023, devem ser confessados espontaneamente antes da adesão ao
        programa, selecionando a opção “Confissão espontânea ISSQN” na página do
        programa em
        <a href="https://reativabh.pbh.gov.br" target="_blank">
        reativabh.pbh.gov.br</a>.
         Após realizar a confissão espontânea, retorne à página do programa e
        selecione a opção “Aderir ao Reativa BH”.<br /><br />

        <strong
          >28 - Minha empresa possui valores não recolhidos referentes ao ISSQN
          e se encontra sob ação fiscal. Posso aderir ao Reativa BH ? </strong
        ><br />
        Sim. Os valores do ISSQN não recolhidos, cujos fatos geradores ocorreram
        até o dia 30/07/2023, podem ser quitados ou parcelados aproveitando os
        descontos do programa.<br />
        Para realizar a adesão ao programa, em razão da empresa se encontrar sob
        ação fiscal, entre em contato com o auditor responsável pela
        fiscalização, para esclarecimentos e instruções.<br /><br />

        <strong
          >29 - Minha empresa foi autuada por descumprimento à legislação do
          ISSQN. Posso quitar ou parcelar o auto de infração no Reativa BH ? </strong
        ><br />
        Sim. As multas aplicadas em decorrência do descumprimento de obrigações
        acessórias relativas ao ISSQN, vencidas até 31/08/2023, poderão ser
        quitadas ou parceladas no programa, com descontos de 20% a 80% sobre o
        valor da autuação, conforme a modalidade de regularização escolhida.<br /><br />

        <strong
          >30 - Empresa que fez adesão ao parcelamento do programa REATIVA
          poderá, em 2024 enquadrar-se no Simples Nacional ?</strong
        ><br />
        Sim, desde que o parcelamento esteja adimplente e não haja outros
        débitos em aberto.<br /><br />

        <strong>  
          31 - Sou servidor exonerado. Tenho que aderir ao programa Reativa BH ? Por quê ?
        </strong><br />  
          Se você gozou de afastamento não remunerado em algum momento a partir de 2012, 
          e não repassou a contribuição previdenciária, nos termos da Lei 10.362/2011, 
          está em débito com o RPPS de Belo Horizonte e, considerando o caráter contributivo 
          e solidário de financiamento dos regimes próprios, é devida a quitação dos valores 
          pendentes. Caso você não regularize o seu débito, seu nome poderá ser inscrito 
          em dívida ativa, nos termos da legislação municipal. 
          A vantagem de regularizar seu débito via programa Reativa BH é a possibilidade de 
          ter até 100% de desconto sobre multas e juros, a depender do plano de quitação escolhido.
        <br /><br />  

        <strong>  
          32 - Sou servidor aposentado. Tenho que aderir ao programa Reativa BH? Por quê ?
        </strong><br />
          Se você gozou de afastamento não remunerado em algum momento a partir de 2012, 
          e não repassou a contribuição previdenciária, nos termos da Lei 10.362/2011, 
          está em débito com o RPPS de Belo Horizonte e, considerando o caráter contributivo 
          e solidário de financiamento dos regimes próprios, é devida a quitação dos valores 
          pendentes. Caso você não regularize o seu débito, seu nome poderá ser inscrito em 
          dívida ativa, nos termos da legislação municipal. A vantagem de regularizar seu 
          débito via programa Reativa BH é a possibilidade de ter até 100% de desconto sobre 
          multas e juros, a depender do plano de quitação escolhido.
        <br /><br />  

        <strong>  
          33 - Já estou aposentado, mesmo assim, preciso regularizar o débito ?
        </strong><br />
          Se o débito não estiver prescrito, você deve quitá-lo, para evitar que seu nome 
          seja inscrito em dívida ativa. 
        <br /><br />  

        <strong>  
          34 - Mesmo não me aposentando pela prefeitura de Belo Horizonte, tenho que regularizar o débito ?
        </strong><br />  
          Sim, porque o financiamento é compulsório, contributivo e solidário. 
          O tempo é considerado, para fins de aposentadoria, e há uma compensação 
          desses créditos entre os regimes. Por exemplo, se você se aposentar pelo INSS, 
          por meio de uma certidão de tempo de contribuição (CTC), você levará este tempo 
          para lá, e os créditos repassados ao RPPS de Belo Horizonte serão compensados 
          com o Regime Geral de Previdência. O mesmo acontecerá caso você se aposente em 
          outro regime próprio (de outro ente governamental, por exemplo).
        <br /><br />  

        <!-- <strong>  
          29- E como saber se eu estou devendo algo, e o que estou devendo ? 
        </strong><br />
          Se você acessar a página do programa <a href="https://reativabh.pbh.gov.br" target="_blank"
          >Reativa BH</a>, e seguir o passo a passo do tutorial, disponível na página, ]
          verificará os débitos existentes em seu nome. Ao passar o cursor sobre cada um dos 
          lançamentos, constará a informação do que se trata. Os débitos previdenciários, 
          ou seja, correspondentes às contribuições não recolhidas, têm número de lançamento 
          começando com os dígitos 16.304… a 16.313… Vale lembrar que, em razão da Lei Geral 
          de Proteção de Dados, o acesso deve ser realizado via “gov.br”.<br />

          Importante destacar que nem todos os débitos são elegíveis ao Programa Reativa BH, 
          razão pela qual aconselhamos que você também verifique se constam valores pendentes 
          em seu nome no portal <a href="https://siatu-tributario.pbh.gov.br/guias" target="_blank"
          >siatu-tributario.pbh.gov.br/guias</a>. 
        <br /><br />   -->

        <strong>
          35 - E como saber se o valor está prescrito ?
        </strong><br />
          Ao acessar a página do Programa Reativa BH, serão listados todos os valores que 
          você deve ao Município de Belo Horizonte. Ao passar o cursor sobre eles, a página 
          mostra, de forma resumida, a que se referem. Os valores listados são os valores 
          não prescritos, ainda ativos, nos termos da legislação tributária municipal. 
          Para consultar débitos não contemplados no programa Reativa BH, verifique no 
          portal: <a href="https://siatu-tributario.pbh.gov.br/guias" target="_blank"
          >siatu-tributario.pbh.gov.br/guias</a>.
        <br /><br />  

        <strong>
          36 - Devo somente a cota patronal (22%) e tenho liminar/tutela antecipada judicial. 
          Tenho que aderir ao programa Reativa-BH ?
        </strong><br />
          Você pode negociar no Programa Reativa BH qualquer lançamento de débito tributário, 
          mesmo aqueles que estão suspensos por força de decisão judicial ainda não definitiva. 
          Neste caso, você estará desistindo da ação judicial, nos termos da lei do Programa Reativa BH.<br /> 

          A vantagem de regularizar seu débito via programa é a possibilidade de ter até 100% 
          de desconto sobre multas e juros, a depender do plano de quitação escolhido.<br /> 

          É importante deixar claro que, havendo processo judicial ou administrativo em andamento, 
          o cidadão que aderir ao Programa Reativa BH encerra a discussão atrelada aos lançamentos 
          negociados na adesão. Ou seja, você pode aderir para aqueles lançamentos em que abrirá 
          mão da discussão administrativa ou judicial e não aderir para aqueles em que entende 
          que o processo (administrativo ou judicial) deve continuar.<br /> 

          Caso você não faça a adesão ao programa, e o processo (administrativo ou judicial) seja 
          julgado indeferido, o débito será cobrado com todas as atualizações, multas e juros, e 
          o seu nome poderá ser inscrito em dívida ativa, nos termos da legislação municipal.
        <br /><br /> 

        <strong>   
          37 - Encaminhei defesa acerca do período de LSV, pois discordo da cobrança da contribuição 
          previdenciária. Diante disso, tenho que aderir ao Programa Reativa BH ?
        </strong><br />
          Nos termos da Lei 10.362, de 2011, o repasse da contribuição previdenciária durante 
          o período de afastamento sem vencimento passou a ser obrigatório a partir de 01/04/2012. 
          Sua defesa segue em análise pela administração. Em caso de indeferimento, os débitos 
          serão cobrados com correção, multa e juros, nos termos da Lei. Assim, recomenda-se a 
          adesão ao Programa Reativa BH, que está dando a oportunidade de regularização dos 
          valores pendentes com até 100% de desconto sobre multas e juros, a depender do plano 
          de quitação escolhido.<br />  

          Destaca-se que, aderindo ao programa, você abrirá mão da discussão administrativa ou 
          judicial dos lançamentos inseridos na negociação.  
        <br /><br />  
 
         <strong>
          38 - Quitando o débito, o tempo será contado ?
        </strong><br />
          Os períodos para os quais houver quitação dos débitos relativos a contribuições não 
          repassadas durante afastamentos sem remuneração serão contados apenas para fins de 
          aposentadoria, nos termos da Lei 10.362/2011. Ressalta-se que, para isso, o débito 
          precisa estar integralmente quitado até a data de requerimento da contagem de tempo, 
          ou na Certidão de Tempo de Contribuição - CTC, no caso de servidor exonerado.
        <br /><br /> 

        <strong> 
          39 - Quero pagar a contribuição previdenciária de período de licença sem vencimentos 
          anterior à obrigatoriedade do repasse trazida pela Lei 10.362/2011 
          (obrigatoriedade a partir de 01/04/2012). É possível através do Programa Reativa BH ?
        </strong><br />
          Não é possível. Antes de abril de 2012, o repasse não era obrigatório nas situações de 
          afastamento não remunerado. Neste caso, não se trata de débito, e para o pagamento destes 
          valores junto ao RPPS-BH, caso seja do seu interesse contar o respectivo tempo para 
          fins de aposentadoria, é necessário abrir processo administrativo para avaliação, caso 
          a caso. A abertura do processo é feita por meio de agendamento na central de atendimento 
          da Secretaria Municipal de Planejamento, Orçamento e Gestão, solicitado pelo e-mail 
          agendamentoeletronico.pbh.gov.br. 
        <br /><br />  

        <strong>
          40 - Por que tenho que pagar a patronal? O Município de Belo Horizonte não alterou a 
          legislação, transferindo para o Ente a responsabilidade pelo recolhimento da cota patronal ?
        </strong><br />
          O artigo 22 da Lei nº 10.362, de 2011, foi alterado pela Lei nº 11.144, de 21 de dezembro 
          de 2018, que determinou que apenas a cota funcional fosse de responsabilidade do 
          servidor afastado sem remuneração. Mas o referido dispositivo não retroagiu seus efeitos, 
          que foram produzidos somente a partir de 22 de março de 2019. Antes disso, permaneceram sendo 
          de responsabilidade do servidor afastado sem remuneração ambas as cotas, funcional e patronal.
        <br /><br />  

        <strong>
          41 - Não concordo/Quero entender melhor os valores apresentados na página do Programa Reativa-BH. O que fazer ?
        </strong><br />
          O valor que está sendo cobrado corresponde à contribuição previdenciária funcional 
          de 11% (para períodos anteriores a abril de 2020) ou de 14% (para períodos a partir de abril de 2020), 
          nos termos do art. 75 da Lei nº 10.362/2011, à contribuição patronal de 22% para os 
          períodos anteriores a 21/03/2019, nos termos do art. 77 combinado com o art. 22 da 
          Lei nº 10.362/2011, incidentes sobre a respectiva base de contribuição da remuneração do 
          cargo da época do afastamento, corrigidos nos termos do art. 91 da Lei nº 10.362/2011 
          combinado com art. 48 do Dec. nº 17.103/2019. 

          Persistindo dúvidas, você deve enviar imediatamente um e-mail para reativalicenciado@pbh.gov.br, 
          ciente do prazo de resposta, que é de 05 (cinco) dias úteis. Recomendamos que o contato seja feito 
          o mais breve possível, para não perder o prazo de adesão ao Programa Reativa BH.

          Os débitos previdenciários correspondentes às contribuições não recolhidas, têm número de 
          lançamento começando com os dígitos 16304… até 16313. Os 3º, 4º e 5º dígitos, contando da 
          esquerda para a direita, identificam o tipo de cota (se funcional ou patronal) e o 
          órgão de origem do servidor / ex-servidor, cuja tabela de correspondência pode ser 
          verificada a seguir: 

          <table class="w-50 mt-3 mb-3">
          <tr class="text-center">
            <th>Órgão de origem</th>
            <th>Cota FUNCIONAL</th> 
            <th>Cota    PATRONAL</th>
          </tr>
          <tr class="text-center">
            <td>PBH</td>
            <td>304</td>
            <td>309</td>
          </tr>
          <tr class="text-center">
            <td>HOB</td>
            <td>305</td>
            <td>310</td>
          </tr>
          <tr class="text-center">
            <td>FMC</td>
            <td>306</td>
            <td>311</td>
          </tr>
          <tr class="text-center">
            <td>FPMZB</td>
            <td>307</td>
            <td>312</td>
          </tr>
          <tr class="text-center">
            <td>CMBH</td>
            <td>308</td>
            <td>313</td>
          </tr>          
        </table>

        Ao passar o cursor sobre cada um dos lançamentos, constará a referência do débito (competência)
        Vale lembrar que, em razão da Lei Geral de Proteção de Dados, o acesso deve ser realizado via 
        <a href="https://gov.br" target="_blank"
          >gov.br</a>.
        Importante destacar que nem todos os débitos são elegíveis ao Programa Reativa BH, razão pela qual 
        aconselhamos que V.Sra também verifique se constam valores pendentes em seu nome 
        no portal: <a href="https://siatu-tributario.pbh.gov.br/guias" target="_blank"
          >siatu-tributario.pbh.gov.br/guias</a>.
        <br /><br />  
 
        <!-- <strong>
          40- Eu aderi ao programa Reativa em 2021, quitei tudo à vista / já paguei algumas parcelas, 
          mas ainda assim constam débitos em meu nome no programa Reativa de 2023. Por que ?
        </strong><br /> 
          O Município pode rever de ofício, a qualquer tempo, os lançamentos tributários 
          legalmente constituídos, e se há algum débito sendo listado, pode representar alguma 
          correção de valor ao lançamento original, ou mesmo competências que não foram 
          listadas anteriormente no Programa Reativa de 2021 por indisponibilidade do próprio 
          sistema. Sendo débito listado no Reativa de 2023, é devido e pode compor proposta de 
          negociação com os benefícios do programa atual. Recomendamos a adesão, para a 
          garantia dos descontos e a não inscrição em dívida ativa.
        <br /><br />   -->      
      </ul>
    </b-modal>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import axios from "axios";
import constantes from "../constants";
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import BotaoInicial from "../components/BotaoInicial.vue"

export default {
  components: {
    loading,
    BotaoInicial
  },
  directives: {
    mask,
  },
  data() {
    return {
      carregando: false,
      numeroGuia: "",
      mensagemErroGuia: "",

      mostrarSobre: false,
      permissaoAcesso: false,
     
     userName: this.$store.getters.userInfo.preferred_username,
      origemAcesso: this.$store.getters.userInfo.origem,

    };
  },

  methods: {
    enviarGuiar: async function () {
      this.carregando = true;
      const numeroGuia = this.numeroGuia;
      this.mensagemErroGuia = "";
      await axios
        .post(this.$env.url_backend + constantes.geraRelacaoLancamento, {
          numeroGuia,
        })
        .then((response) => {
          const url = response.data;
          if (url[0]) window.open(url, "_blank");
          else this.mensagemErroGuia = "Guia não encontrada.";
          this.carregando = false;
        })
        .catch(() => {
          this.mensagemErroGuia = "Erro ao abrir a Guia";
          this.carregando = false;
        });
    },

    abrirModal: function (referencia) {
      this.$refs[referencia].show();
    },

    fecharModal: function (referencia) {
      this.$refs[referencia].hide();
    },

    limparCampos: function () {
      this.numeroGuia = "";
      this.mensagemErroGuia = "";
    },
  },

  async beforeMount() {
    this.userName = this.$store.getters.userInfo.preferred_username;
    this.origemAcesso = this.$store.getters.userInfo.origem;
  },

 async mounted() {
    await axios
      .post(this.$env.url_backend + constantes.verificaPermissao, {
           userName: this.userName,
       })
      .then((response) => {
        const retorno = response.data;
        this.permissaoAcesso = retorno;       
      })
      .catch(() => {
        this.mensagemErro.push(
          "PÁGINA EM MANUTENÇÃO, FAVOR ACESSAR MAIS TARDE."
        );
        window.scrollTo(0, 0);
      });  
  },
};

</script>


<style scoped>
.table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}

.row-gap-md {
    row-gap: 2rem;
}

.apresentacao {
  font-size: 1em;
  text-align: justify;
}

.texto-apresentacao {
  column-width: 400px;
  column-gap: 1.5rem;
}

.bg-img-sm {
  display: none;
}

.link-card {
  text-decoration: none;
  color: #000;
  cursor: pointer;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .bg-img-sm {
    background-image: url(/imgs/fundo.png);
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;
    width: 100%;
    min-height: 14rem;
    display: block;
  }
}

.logo-prefeitura {
  margin: 15px;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.7);
}

.pagina-inicial {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.botao-icone {
  font-size: 1.15rem;
  display: inline-block;
  margin: 15px;
  vertical-align: middle;
  cursor: pointer;
  overflow: hidden;
}

.botao-icone a {
  display: inline-block;
  position: relative;
  width: 180px;
  height: 180px;
  padding: 15px;
  text-align: center;
  color: #007632;
  background-image: linear-gradient(135deg, #fff 90%, transparent 90%);
  transition: 0.5s;
}

.botao-icone a:hover {
  text-decoration: none;
  color: var(--cor-base);
}

.botao-icone .icon {
  margin: 15px auto;
  display: block;
}

.botao-video {
  font-size: 1.15rem;
  display: inline-block;
  margin: 15px;
  vertical-align: middle;
  cursor: pointer;
  overflow: hidden;
}

.botao-video a {
  display: inline-block;
  position: relative;
  width: 100%;
  height: 80px;
  padding: 15px;
  text-align: center;
  color: var(--cor-base);
  transition: 0.5s;
}

.botao-video a:hover {
  text-decoration: none;
  color:  var(--cor-base);
}

.botao-video .icon {
  margin: 10px auto;
  display: block;
}

.iframe-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;
}
.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
